module.exports = __webpack_public_path__ + "img/footer_bg-new.72f3604b.png";